import Tag from "@/models/tag/tag";
import { PATH_KEYS } from "../services/appServices";
import { useItemsCrud } from "./useItemsCrud";
import { useItemService } from "./useServices";

const useTags = () => {
  /**** Services ****/
  useItemService((services) => services.tag);

  const tagCrud = useItemsCrud<Tag>(
    [PATH_KEYS.tag],
    (services) => services.tag
  );

  /**** Queries & Mutations ****/

  /**** Value ****/
  return {
    ...tagCrud,
  };
};

export default useTags;
